/** biome-ignore-all lint/suspicious/noExplicitAny: Deals with legacy code */
/**
 * Handles referral tracking by reading URL query params and persisting
 * referral codes to localStorage. Called from TopBar.componentDidUpdate
 * when the router query changes.
 */
export function handleReferralTracking(
  query: Record<string, any>,
  onReferralClick: (code: string) => void
) {
  const psCode = query.ps;
  const rtCode = query.rt;
  const asCode = query.as;
  const urCode = query.referral;
  const irclickid = query.irclickid;

  const hasExistingProfitShare = !!localStorage.getItem('partner_code');
  const hasExistingAffiliate = !!localStorage.getItem('as_code');
  const rsRsCode = process.env.NEXT_PUBLIC_REFERRAL_SCHEME ?? '';
  const psRsCode = process.env.NEXT_PUBLIC_PROFIT_SHARE_SCHEME ?? '';
  const asRsCode = process.env.NEXT_PUBLIC_AFFILIATE_SCHEME ?? '';
  const imRsCode = process.env.NEXT_PUBLIC_IMPACT_SCHEME ?? '';

  // Referral tracking
  if (rtCode) {
    localStorage.setItem('rt_code', rtCode);
    onReferralClick(rtCode);
  }

  // Profit share partners
  if (psCode) {
    localStorage.setItem('partner_code', psCode);
    localStorage.setItem('rt_code', psRsCode);

    if (hasExistingAffiliate) {
      localStorage.removeItem('as_code');
    }
  }

  // Affiliate Scheme
  if (asCode) {
    localStorage.setItem('as_code', asCode);
    localStorage.setItem('rt_code', asRsCode);

    if (hasExistingProfitShare) {
      localStorage.removeItem('partner_code');
    }
  }

  // User Referral Scheme
  if (urCode) {
    localStorage.setItem('user_referral_code', urCode);

    if (rtCode !== process.env.NEXT_PUBLIC_MINI_SPONSOR) {
      localStorage.setItem('rt_code', rsRsCode);
      onReferralClick(rsRsCode);
    }
  }

  // Impact tracking
  if (irclickid) {
    localStorage.setItem('irclickid', irclickid);
    localStorage.setItem('rt_code', imRsCode);

    if (hasExistingAffiliate) {
      localStorage.removeItem('as_code');
    }

    if (hasExistingProfitShare) {
      localStorage.removeItem('partner_code');
    }
  }
}
